'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBottomRightBoundaryPoint = exports.getTopLeftBoundaryPoint = exports.getAveragePoint = exports.getPointBetween = exports.getPointBetweenY = exports.getPointBetweenX = exports.getPointBetween1D = exports.getDistance = exports.getDelta = exports.getYDelta = exports.getXDelta = exports.get1DDelta = exports.getPoint = undefined;

var _fp = require('lodash/fp');

var _immutableHelper = require('../../utils/immutableHelper');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Lib


// Utils


// √
var getPoint = exports.getPoint = function getPoint(x, y) {
    return { x: x, y: y };
};

// √
var get1DDelta = exports.get1DDelta = function get1DDelta(from, to, dimension) {
    return to[dimension] - from[dimension];
};
var getXDelta = exports.getXDelta = function getXDelta(from, to) {
    return get1DDelta(from, to, 'x');
};
var getYDelta = exports.getYDelta = function getYDelta(from, to) {
    return get1DDelta(from, to, 'y');
};
var getDelta = exports.getDelta = function getDelta(from, to) {
    return getPoint(getXDelta(from, to), getYDelta(from, to));
};
var getDistance = exports.getDistance = function getDistance(from, to) {
    return Math.hypot(getXDelta(from, to), getYDelta(from, to));
};

// √
var getPointBetween1D = exports.getPointBetween1D = function getPointBetween1D(point1, point2, dimension, fraction) {
    return point1[dimension] + (point2[dimension] - point1[dimension]) * fraction;
};
var getPointBetweenX = exports.getPointBetweenX = function getPointBetweenX(point1, point2, fraction) {
    return getPointBetween1D(point1, point2, 'x', fraction);
};
var getPointBetweenY = exports.getPointBetweenY = function getPointBetweenY(point1, point2, fraction) {
    return getPointBetween1D(point1, point2, 'y', fraction);
};
var getPointBetween = exports.getPointBetween = function getPointBetween(point1, point2) {
    var fraction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.5;
    return getPoint(getPointBetweenX(point1, point2, fraction), getPointBetweenY(point1, point2, fraction));
};

/**
 * Calculates an average point given an array of points passed in.
 * It sums all the dimensions of each point and then returns the sum divided by the number of points.
 *
 * E.g. For three points:
 * x = (p1.x + p2.x + p3.x) / 3, y = (p1.y + p2.y + p3.y) /3
 */
var getAveragePoint = exports.getAveragePoint = function getAveragePoint(points) {
    return points.reduce(function (acc, point, index) {
        acc.x += point.x;
        acc.y += point.y;

        // If the final point take the average and return it to the caller
        if (index === points.length - 1) {
            acc.x /= points.length;
            acc.y /= points.length;
        }
        return acc;
    }, getPoint(0, 0));
};

var choosePoint = (0, _fp.curry)(function (selectorFn, axis, points) {
    return selectorFn.apply(undefined, _toConsumableArray(points.map((0, _immutableHelper.prop)(axis))));
});
var getLeftBoundary = choosePoint(Math.min, 'x');
var getRightBoundary = choosePoint(Math.max, 'x');
var getTopBoundary = choosePoint(Math.min, 'y');
var getBottomBoundary = choosePoint(Math.max, 'y');
var getTopLeftBoundaryPoint = exports.getTopLeftBoundaryPoint = function getTopLeftBoundaryPoint(points) {
    return getPoint(getLeftBoundary(points), getTopBoundary(points));
};
var getBottomRightBoundaryPoint = exports.getBottomRightBoundaryPoint = function getBottomRightBoundaryPoint(points) {
    return getPoint(getRightBoundary(points), getBottomBoundary(points));
};


//////////////////
// WEBPACK FOOTER
// ./src/common/documentOrder/geometry/point.js
// module id = 242
// module chunks = 0